import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/providers/AuthProvider';

type ProtectedRouteProps = {
  allowedRoles?: string[];
};

export default function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { user, authLoading } = useAuth();

  const location = useLocation();

  if (authLoading) {
    return <div>Loading session...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isAuthorized = allowedRoles ? allowedRoles.includes(user.role) : true;

  if (!isAuthorized) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
